/**
 * @deprecated Please import from dedicated constant files:
 * - OGP: @/constants/ogp
 * - Routes: @/constants/routes
 * - Form: @/constants/form
 * - Sidemenu: @/constants/sidemenu
 * 
 * This file re-exports for backward compatibility
 */

// Re-export from dedicated files
export { OgpImageUrl } from "@/constants/ogp";
export { NEXT_URL } from "@/constants/routes";
export {
  GENDER_OPTIONS,
  PREF_OPTIONS,
  INDUSTRY_OTHER_ID,
  CUSTOM_OTHER_FIELD_ID,
  DATE_FORMAT,
  JP_FULL_DATE_FORMAT,
  JP_FULL_DATE_TIME_FORMAT,
} from "@/constants/form";
export {
  sideMenuAccordionItems,
  sideMenuTopItems,
  sideMenuBottomItems,
} from "@/constants/sidemenu";

// Legacy exports (keep for backward compatibility)
export const PREF_FIELD_NAME = "prefectureId";
export const INDUSTRY_FIELD_NAME = "industryId";
export const HOURS_MINUTES_FORMAT = "HH:mm";
export const DEFAULT_WIDTH = 920;
export const JP_DATE_FORMAT = "yyyy年MM月dd日";
